import Link from "next/link";
import type { MarketingLink } from "../marketing.type";

interface BreadcrumbsProps {
  // Ancestors only - the current page is passed as `current`.
  trail: MarketingLink[];
  current: string;
}

// Website 2.0 breadcrumb strip. Sits on the same dark background as the
// hero below it, so the two read as one block.
const Breadcrumbs = ({ trail, current }: BreadcrumbsProps) => (
  <nav aria-label="Breadcrumb" className="bg-secondary-2 pt-[18px] text-sm text-white/70">
    <div className="site-wrap">
      <ol className="flex flex-wrap gap-x-2.5 gap-y-1">
        {trail.map((crumb) => (
          <li
            key={crumb.route}
            className="after:ml-2.5 after:text-white/40 after:content-['/']"
          >
            <Link href={crumb.route} className="hover:text-white hover:underline">
              {crumb.label}
            </Link>
          </li>
        ))}
        <li>
          <span aria-current="page" className="font-semibold text-white">
            {current}
          </span>
        </li>
      </ol>
    </div>
  </nav>
);

export default Breadcrumbs;
